import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=9810219e&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9810219e",
  null
  
)

export default component.exports